<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-row>
                <b-col v-for="(item, index) in listImages" :key="index">
                    <h2 class="text-center">Hình ảnh {{ index + 1 }}</h2>
                    <b-img
                        thumbnail
                        fluid
                        :src="`${API_CONFIG.URL_GET_GEOJSON}${item.path}`"
                    ></b-img>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import API_CONFIG from '@/api-config';
import CONSTANTS from '@/constants';
export default {
    async mounted() {
        await this.$nextTick();
        this.listImages = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.PNG
        });
    },
    data() {
        return {
            listImages: [],
            API_CONFIG
        };
    },
    methods: {
        ...mapActions({
            getListGeoJson: 'geojson/getList'
        })
    }
};
</script>
